import React from 'react'
import { ComponentOrElement } from './typings.d'
// Determine whether the incoming component has been instantiated
// AuthorizedRoute is already instantiated
// Authorized  render is already instantiated, children is no instantiated
// Secured is not instantiated
export const checkIsInstantiation = (target: ComponentOrElement): React.ComponentType => {
  if (!React.isValidElement(target)) {
    return target as React.ComponentType
  }

  return () => target
}

export default {
  checkIsInstantiation,
}
